import { jsx as _jsx } from "react/jsx-runtime";
import { formatDuration } from "@air/utilities";
import { ClipUtils, isPdfRenderedExtension } from "@air/utils-clips";
import { memo } from "react";
export const GalleryAssetShortInfo = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    const isGifExtension = clip.ext === "gif";
    const isPdfExtension = isPdfRenderedExtension(clip.ext);
    var _clip_duration;
    const time = formatDuration((_clip_duration = clip.duration) !== null && _clip_duration !== void 0 ? _clip_duration : 0);
    const transcoded = ClipUtils.isTranscoded(clip.status);
    const videoTime = clip.type === "video" && transcoded && time;
    const value = isGifExtension ? "GIF" : isPdfExtension ? "PDF" : videoTime;
    if (!value) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "absolute bottom-3 right-3 flex h-4 items-center rounded-2 bg-black/80 px-1 text-10 font-medium uppercase text-white opacity-100 font-feature-tnum group-data-[hovering=true]/gallery-selectable-card:opacity-0",
        children: value
    });
});
GalleryAssetShortInfo.displayName = "GalleryAssetShortInfo";
